import DetailChart from './DetailChart';

export default DetailChart;
